<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Win streak event (id {{winStreakId}})</h2>
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'WinStreak',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    winStreakId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Info',
          route: {name: 'win_streak_info', params: {winStreakId: this.winStreakId}},
        },
      ];
    },
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
